var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlane = function SvgPlane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3 21.48 15 13.5h5.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5H15l-4.7-7.98C10.12 2.2 9.77 2 9.4 2c-.7 0-1.2.67-1.01 1.34l2.1 7.16H5L3.65 8.24A.51.51 0 0 0 3.22 8h-.58c-.33 0-.57.31-.49.62l.73 2.92L3 12l-.09.38-.11.42-.48 1.9-.17.67c-.08.32.16.62.49.62h.58c.18 0 .34-.09.43-.24L5 13.5h5.5l-2.1 7.16c-.2.67.3 1.34 1 1.34.37 0 .72-.2.9-.52"
  })));
};
export default SvgPlane;